import { render, staticRenderFns } from "./PrivilegeActions.vue?vue&type=template&id=0181b9d0&"
import script from "./PrivilegeActions.vue?vue&type=script&lang=js&"
export * from "./PrivilegeActions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports